import React, { useEffect, useLayoutEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./../Navbar/Navbar.css";
import { ProductConsumer } from "../Context/AddProWakel";
import { ButtonContainer } from "./../Components/ButtonContainerSe";
import { isDesktop } from "react-device-detect";
import MobileShell from "./MobileShell";

// Below this width the desktop icon bar no longer fits on one line (it wraps
// and covers the page header), so phones and tablets get the app shell instead.
const COMPACT_QUERY = "(max-width: 1199.98px)";

const Navbar = () => {
  const location = useLocation();
  const [isCompact, setIsCompact] = useState(
    () => window.matchMedia(COMPACT_QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(COMPACT_QUERY);
    const onChange = (e) => setIsCompact(e.matches);
    // Safari < 14 only has the deprecated addListener.
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  // Every page that shows the navbar gets body.app-shell while the shell is
  // active. All of responsive.css hangs off that class, so pages WITHOUT a
  // navbar — the print layouts, the login form — are never restyled. A layout
  // effect so the class swap between two pages happens before the paint.
  useLayoutEffect(() => {
    if (!isCompact) return undefined;
    document.body.classList.add("app-shell");
    return () => document.body.classList.remove("app-shell");
  }, [isCompact]);

  return (
    <ProductConsumer>
      {(value) => {
        const {
          navdolar,
          DolarChange,
          role,
          logoutUser,
          disabled_navdolar,
          toggleNavdolar,
          R_zh_wasl_katy,
          D_OpenModal,
          L_user,
          JM_OpenModal,
          K_OpenModal,
          RB_OpenModal,
          R_table,
          HK_pshandan,
          A_OpenModal,
          KD_pshandan,
          IO_OpenModal,
          RDM_OpenModal,
          IT_table,
          OR_pendingCount,
          AL_todayCount
        } = value;
        if (isCompact) return <MobileShell value={value} />;
        return (
          <>
          <nav className="navbar navbar-expand-lg fixed-top">
            <Link to="/">
              <span className="navbar-brand">
                <i className="fas fa-home mx-2 fa-sm text-white"></i>
                <span className="mx-2 text-white">ماڵەوە</span>
              </span>
            </Link>

            <button
              className="navbar-toggler p-0"
              type="button"
              data-toggle="collapse"
              data-target="#collapsibleNavbar"
            >
              <span className="navbar-toggler-icon">
                <i className="fas fa-bars"></i>
              </span>
            </button>

            <div className="collapse navbar-collapse" id="collapsibleNavbar">
              <ul className="navbar-nav">
                <li
                  className="nav-item"
                  onClick={(e) => {
                    A_OpenModal(e, L_user._id);
                  }}
                >
                  <Link to={`/add-user`} className="text-white">
                    <span className="nav-link">
                      <i className="fas fa-user text-white"></i>
                    </span>
                  </Link>
                </li>

                <li className="nav-item">
                  <input
                    type="text"
                    maxLength="7"
                    value={
                      navdolar === "" || navdolar === null || navdolar === undefined
                        ? ""
                        : Number(String(navdolar).replace(/,/g, "")).toLocaleString("en-US")
                    }
                    disabled={disabled_navdolar ? false : true}
                    className="form-control text-right"
                    placeholder="...نرخی دۆلار"
                    onChange={DolarChange}
                  />
                </li>
                {role == "ipadadmin" || role == "admin" ? (
                  <li className="nav-item" onClick={toggleNavdolar}>
                    <span className="nav-link">
                      <i className="fas fa-dollar-sign text-white"></i>
                      <label className="text-white my-0 ml-lg-2 f5">
                        نرخی دۆلار
                      </label>
                    </span>
                  </li>
                ) : null}

                <li className="nav-item dropdown">
                  <span className="badge badge-pill float-right badge-success"></span>
                </li>



              </ul>

              {isDesktop ?
                <ul className="navbar-nav mr-5">
                    {(role == "ipadadmin" || role == "admin") && (
                      <Link to="/audit-log">
                        <span
                          className="navbar-brand"
                          title="وردبینی — گۆڕانکارییەکانی ئەمڕۆ"
                          style={{ cursor: "pointer", transition: "transform 0.2s", position: "relative", display: "inline-block" }}
                          onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                          onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                        >
                          <i
                            className="fas fa-history fa-lg"
                            style={{ color: "#9b59b6" }}
                          ></i>
                          {AL_todayCount > 0 && (
                            <span
                              className="badge badge-pill badge-danger"
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                fontSize: "0.65rem",
                                lineHeight: "1",
                                padding: "3px 5px",
                                boxShadow: "0 0 0 1px #fff"
                              }}
                            >
                              {AL_todayCount > 99 ? "99+" : AL_todayCount}
                            </span>
                          )}
                        </span>
                      </Link>
                    )}
                  <Link to="/online-orders">
                    <span
                      className="navbar-brand"
                      title="داواکارییەکانی ئۆنڵاین"
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <i
                        className="fas fa-receipt fa-lg"
                        style={{ color: "#ff7f50" }}
                      ></i>
                      {OR_pendingCount > 0 && (
                        <span
                          className="badge badge-pill badge-danger"
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            fontSize: "0.65rem",
                            lineHeight: "1",
                            padding: "3px 5px",
                            boxShadow: "0 0 0 1px #fff"
                          }}
                        >
                          {OR_pendingCount > 99 ? "99+" : OR_pendingCount}
                        </span>
                      )}
                    </span>
                  </Link>
                  <Link to="/categories">
                    <span
                      className="navbar-brand"
                      title="جۆرەکان"
                    >
                      <i
                        className="fas fa-tags fa-lg"
                        style={{ color: "#2ecc71" }}
                      ></i>
                    </span>
                  </Link>
                  <span
                    className="navbar-brand"
                    onClick={(e) => RDM_OpenModal(e, L_user._id)}
                  >
                    <i
                      className="fas fa-sitemap fa-lg"
                      style={{ color: "#88771f" }}
                    ></i>
                  </span>
                  <span
                    className="navbar-brand"
                    onClick={(e) => IO_OpenModal(e, L_user._id)}
                  >
                    <i
                      className="fas fa-file fa-lg"
                      style={{ color: "#699669" }}
                    ></i>
                  </span>
                  <Link to="/All-Koga-detail">
                    <span
                      className="navbar-brand"
                      onClick={(e) => KD_pshandan(e, L_user._id)}
                    >
                      <i
                        className="fa fa-info-circle fa-lg"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </Link>
                  <Link to="/MarketSale">
                    <span
                      className="navbar-brand"
                      style={{ color: "#eac11e" }}
                    >
                      <i class="fas fa-money-check-alt"></i>
                    </span>
                  </Link>
                  <Link to="/All-Koga-3arz">
                    <span
                      className="navbar-brand"
                      onClick={(e) => HK_pshandan(e, L_user._id)}
                    >
                      <i
                        className="fa fa-shopping-basket fa-lg"
                        style={{ color: "#24baf0" }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </Link>
                  <Link to="/text-bord">
                    <span className="navbar-brand">
                      <i
                        className="fas fa-pen-square fa-lg"
                        style={{ color: "#C9AA49" }}
                      ></i>
                    </span>
                  </Link>
                  <Link to="/add-product">
                    <span className="navbar-brand">
                      <i
                        className="fas fa-shopping-cart fa-lg"
                        style={{ color: "#fcb25f" }}
                      ></i>
                    </span>
                  </Link>

                  <Link to={`/rent?page=${R_zh_wasl_katy}`}>
                    <span className="navbar-brand">
                      <i
                        className="fas fa-cart-plus fa-lg"
                        style={{ color: "#d5fe77" }}
                      ></i>
                    </span>
                  </Link>

                  <Link to="/add-wakel">
                    <span className="navbar-brand">
                      <i className="fas fa-users fa-lg"></i>
                    </span>
                  </Link>

                  <Link to="/take-money">
                    <span className="navbar-brand">
                      <i
                        className="fas fa-cash-register fa-lg"
                        style={{ color: "#7f8aa1" }}
                      ></i>
                    </span>
                  </Link>
                  <span
                    className="navbar-brand"
                    onClick={
                      R_table == true ? null : (e) => D_OpenModal(e, L_user._id)
                    }
                  >
                    <i
                      className="fas fa-calendar-day fa-lg"
                      style={{ color: "#24bbc0" }}
                    ></i>
                  </span>
                  <span
                    className="navbar-brand"
                    onClick={
                      R_table == true
                        ? null
                        : (e) => JM_OpenModal(e, L_user._id)
                    }
                  >
                    <i
                      className="fas fa-store-alt fa-lg"
                      style={{ color: " #E56717" }}
                    ></i>
                  </span>
                  <span
                    className="navbar-brand"
                    onClick={
                      R_table == true ? null : (e) => K_OpenModal(e, L_user._id)
                    }
                  >
                    <i
                      className="fas fa-shopping-bag fa-lg"
                      style={{ color: "#7f992b" }}
                    ></i>
                  </span>
                  <Link to="/masrufat">
                    <span className="navbar-brand">
                      <i
                        className="fas fa-file-invoice-dollar fa-lg"
                        style={{ color: "#f0e7d3" }}
                      ></i>
                    </span>
                  </Link>
                  <Link to={`${R_table == true ? "/rent" : "/setting"}`}>
                    <span className="navbar-brand">
                      <i
                        className="fas fa-cog fa-lg"
                        style={{ color: "#f0e7d3" }}
                      ></i>
                    </span>
                  </Link>
                  <Link to="/old-rasid">
                    <span className="navbar-brand">
                      <i
                        className="fas fa-hand-holding-usd"
                        style={{ color: "#B2A6FF" }}
                      ></i>
                    </span>
                  </Link>
                  <span
                    className="navbar-brand"
                    onClick={
                      R_table == true
                        ? null
                        : (e) => RB_OpenModal(e, L_user._id)
                    }
                  >
                    <i
                      className="fa fa-jpy fa-lg"
                      aria-hidden="true"
                      style={{ color: "rgb(79, 168, 180)" }}
                    ></i>
                  </span>
                </ul> :
                  <div className="dropdown mt2" >
                    <button className="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      بەشەکان
                    </button>
                    <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" style={{ backgroundColor: "#3c3c3c" }}>
                      {(role == "ipadadmin" || role == "admin") && (
                        <Link style={{ textDecoration: "none" }} to="/audit-log">
                          <span className="dropdown-item">
                            <i className="fas fa-history fa-lg" style={{ color: "#9b59b6" }}></i>
                            <span className="text-white  mx-2">بەشی وردبینی</span>
                            {AL_todayCount > 0 && (
                              <span className="badge badge-pill badge-danger">
                                {AL_todayCount > 99 ? "99+" : AL_todayCount}
                              </span>
                            )}
                          </span>
                        </Link>
                      )}
                      <Link style={{ textDecoration: "none" }} to="/online-orders">
                        <span className="dropdown-item">
                          <i
                            className="fas fa-receipt fa-lg"
                            style={{ color: "#ff7f50" }}
                          ></i>
                          <span className="text-white  mx-2">داواکارییەکانی ئۆنڵاین</span>
                          {OR_pendingCount > 0 && (
                            <span className="badge badge-pill badge-danger">
                              {OR_pendingCount > 99 ? "99+" : OR_pendingCount}
                            </span>
                          )}
                        </span>
                      </Link>
                      <Link style={{ textDecoration: "none" }} to="/categories">
                        <span className="dropdown-item">
                          <i
                            className="fas fa-tags fa-lg"
                            style={{ color: "#2ecc71" }}
                          ></i>
                          <span className="text-white  mx-2">جۆرەکان</span>
                        </span>
                      </Link>
                      <span className="dropdown-item" onClick={(e) => RDM_OpenModal(e, L_user._id)}>
                        <i className="fas fa-sitemap fa-lg" style={{ color: "#88771f" }}></i>
                        <span className="text-white  mx-2">ڕاپۆرت کاڵای فرۆشراو</span>
                      </span>
                      <span className="dropdown-item" onClick={(e) => IO_OpenModal(e, L_user._id)}>
                        <i className="fas fa-file fa-lg" style={{ color: "#699669" }}></i>
                        <span className="text-white  mx-2">ڕاپۆرت حساب عام</span>
                      </span>
                      <Link style={{ textDecoration: "none" }} to="/All-Koga-detail">
                        <span
                          className="dropdown-item"
                          onClick={(e) => KD_pshandan(e, L_user._id)}
                        >
                          <i
                            className="fa fa-info-circle fa-lg"
                            aria-hidden="true"
                          ></i>
                          <span className="text-white  mx-2">ڕاپۆرت زانیاری کاڵا</span>
                        </span>
                      </Link>
                      <Link style={{ textDecoration: "none" }} to="/All-Koga-3arz">
                        <span
                          className="dropdown-item"
                          onClick={(e) => HK_pshandan(e, L_user._id)}
                        >
                          <i
                            className="fa fa-shopping-basket fa-lg"
                            style={{ color: "#24baf0" }}
                            aria-hidden="true"
                          ></i>
                          <span className="text-white  mx-2">عەرز</span>
                        </span>
                    </Link>
                    <Link to="/MarketSale">
                      <span className="dropdown-item">
                        <i
                          className="fas fa-money-check-alt fa-lg"
                          style={{ color: "#C9AA49" }}
                        ></i>
                        <span className="text-white  mx-2">مفرد</span>
                      </span>
                    </Link>
                      <Link style={{ textDecoration: "none" }} to="/text-bord">
                        <span className="dropdown-item">
                          <i
                            className="fas fa-pen-square fa-lg"
                            style={{ color: "#C9AA49" }}
                          ></i>
                          <span className="text-white  mx-2">رەفە</span>
                        </span>

                      </Link>
                      <Link style={{ textDecoration: "none" }} to="/add-product">
                        <span className="dropdown-item">
                          <i
                            className="fas fa-shopping-cart fa-lg"
                            style={{ color: "#fcb25f" }}
                          ></i>
                          <span className="text-white  mx-2">زیادکردنی کاڵا</span>
                        </span>
                      </Link>

                      <Link style={{ textDecoration: "none" }} to={`/rent?page=${R_zh_wasl_katy}`}>
                        <span className="dropdown-item">
                          <i
                            className="fas fa-cart-plus fa-lg"
                            style={{ color: "#d5fe77" }}
                          ></i>
                          <span className="text-white  mx-2">فرۆشتن</span>
                        </span>

                      </Link>

                      <Link style={{ textDecoration: "none" }} to="/add-wakel">
                        <span className="dropdown-item">
                          <i className="fas fa-users fa-lg"></i>
                          <span className="text-white  mx-2">زیادکردنی وەکیل</span>
                        </span>
                      </Link>

                      <Link style={{ textDecoration: "none" }} to="/take-money">
                        <span className="dropdown-item">
                          <i
                            className="fas fa-cash-register fa-lg"
                            style={{ color: "#7f8aa1" }}
                          ></i>
                          <span className="text-white  mx-2">پارەوەرگرتن</span>
                        </span>
                      </Link>

                      {/* raporty rozhana */}

                      <span
                        className="dropdown-item"
                        onClick={
                          R_table == true ? null : (e) => D_OpenModal(e, L_user._id)
                        }
                      >
                        <i
                          className="fas fa-calendar-day fa-lg"
                          style={{ color: "#24bbc0" }}
                        ></i>
                        <span className="text-white  mx-2">رەپۆرتی ڕۆژانە</span>
                      </span>

                      {/* raporty jarde maxzan */}
                      <span
                        className="dropdown-item"
                        onClick={
                          R_table == true
                            ? null
                            : (e) => JM_OpenModal(e, L_user._id)
                        }
                      >
                        <i
                          className="fas fa-store-alt fa-lg"
                          style={{ color: " #E56717" }}
                        ></i>
                        <span className="text-white  mx-2">رەپۆرتی مەخزەن</span>
                      </span>

                      {/* raporty kalla */}
                      <span
                        className="dropdown-item"
                        onClick={
                          R_table == true ? null : (e) => K_OpenModal(e, L_user._id)
                        }
                      >
                        <i
                          className="fas fa-shopping-bag fa-lg"
                          style={{ color: "#7f992b" }}
                        ></i>
                        <span className="text-white  mx-2">راپۆرتی کاڵا</span>
                      </span>

                      {/* masrufat */}
                      <Link style={{ textDecoration: "none" }} to="/masrufat">
                        <span className="dropdown-item">
                          <i
                            className="fas fa-file-invoice-dollar fa-lg"
                            style={{ color: "#f0e7d3" }}
                          ></i>
                          <span className="text-white  mx-2">بەشی مەسروفات</span>
                        </span>
                      </Link>

                      {/* setting */}
                      <Link style={{ textDecoration: "none" }} to={`${R_table == true ? "/rent" : "/setting"}`}>
                        <span className="dropdown-item">
                          <i
                            className="fas fa-cog fa-lg"
                            style={{ color: "#f0e7d3" }}
                          ></i>
                          <span className="text-white  mx-2">رێکخستنەکان</span>
                        </span>
                      </Link>
                      {/* old rasid */}
                      <Link style={{ textDecoration: "none" }} to="/old-rasid">
                        <span className="dropdown-item">
                          <i
                            className="fas fa-hand-holding-usd"
                            style={{ color: "#B2A6FF" }}
                          ></i>
                          <span className="text-white  mx-2">قەرزی دەفتەر</span>
                        </span>
                      </Link>
                      {/* raporty bas RRR */}
                      <span
                        className="dropdown-item"
                        onClick={
                          R_table == true
                            ? null
                            : (e) => RB_OpenModal(e, L_user._id)
                        }
                      >
                        <i
                          className="fa fa-jpy fa-lg"
                          aria-hidden="true"
                          style={{ color: "rgb(79, 168, 180)" }}
                        ></i>
                        <span className="text-white  mx-2">راپۆرتی ریمێمبی</span>
                      </span>
                    </div>
                </div> 
              }
              <Link
                to={`${R_table || IT_table.length > 0 ? location.pathname : "/login"}`}
                onClick={R_table || IT_table.length > 0 ? null : logoutUser}
              >
                <ButtonContainer>
                  <span className="mr-3">چوونەدەرەوە</span>
                </ButtonContainer>
              </Link>
            </div>
            </nav>
          </>
        );
      }}
    </ProductConsumer>
  );
};

export default Navbar;
